import React from 'react';
import { useNavigate } from 'react-router-dom';
import { CreateBaulForm } from '@/features/baules/components/CreateBaulForm';
import { useAuthStore } from '@/store/useAuthStore';
import { useBaulesStore } from '@/store/useBaulesStore';
import { useCurrentBaulStore } from '@/store/useCurrentBaulStore';
import { createBaul as storeCreateBaul } from '@/features/baules/useCases';
import { useAuth } from 'react-oidc-context';
import { useUIStore } from '@/store/uiStore';
import { useAsyncAction } from '@/hooks/useAsyncAction';
import { usePostHog } from 'posthog-js/react';

function suggestBaulName(userFullName: string): string {
  const lastName = userFullName.trim().split(/\s+/).pop();
  return lastName ? `Familia ${lastName}` : 'Nuestra Familia';
}

export const CreateBaulRoute: React.FC = () => {
  const navigate = useNavigate();
  const auth = useAuth();
  const { userProfile } = useAuthStore();
  const { baules } = useBaulesStore();
  const { showToastMessage } = useUIStore();
  const { run, isPending } = useAsyncAction();
  const posthog = usePostHog();

  const handleCreateBaul = async (name: string) => {
    if (!auth.isAuthenticated) return;

    const isFirstBaul = baules.length === 0;
    const result = await run(() => storeCreateBaul(name, ''), {
      errorMessage: 'Error al crear el baúl',
    });
    if (!result.ok) return;

    posthog.capture('baul_created', { is_first_baul: isFirstBaul });

    // El baúl recién creado es el que el usuario va a usar a continuación — se convierte en el
    // CurrentBaul para que la app abra ahí la próxima vez, no en el que tuviera activo antes.
    useCurrentBaulStore.getState().setCurrentBaulId(result.value.id);

    navigate(`/baules/${result.value.id}/fotos-sueltas/confirmar`);

    if (isFirstBaul) {
      setTimeout(() => {
        showToastMessage('Tus recuerdos ya están a salvo');
      }, 300);
    }
  };

  return (
    <CreateBaulForm
      onBack={() => navigate('/baules')}
      onSubmit={handleCreateBaul}
      initialName={suggestBaulName(userProfile.name)}
      isSubmitting={isPending()}
    />
  );
};
